import styled from 'styled-components';

export default styled.div`
  font-size: 0.8rem;
  grid-area: path;
`;
